import { useTranslation } from 'react-i18next'

import type { TLeadRepresadoDetalhes } from '@/features/clientes/services/get-lead-represado-por-id.service'
import { EnvioDocumentos } from '@/features/enviar-documentos/components'
import { listaDocumentosPessoaFisica } from '@/features/enviar-documentos/entities'
import type { TEnvioDocumentosConfig } from '@/features/enviar-documentos/interfaces'
import { useTypedLocation } from '@/hooks/use-typed-location'
import { Page } from '@/layouts/page'
import { recuperarDocumentosLeadQueryOptions, useEnviarDocumentosLead } from '@/pages/envio-documentos-leads/api'

export const EnvioDocumentosLeadsPage = () => {
  const { state } = useTypedLocation<{ pessoa: TLeadRepresadoDetalhes }>()
  const { mutateAsync: enviarDocumento } = useEnviarDocumentosLead(state.pessoa.id)

  const config: TEnvioDocumentosConfig = {
    pessoa: { tipo: 'lead_represado', nome: state.pessoa.nome, documento: state.pessoa.cpf },
    documentTypes: listaDocumentosPessoaFisica.toSorted((a, b) => a.label.localeCompare(b.label)),
    backButtonText: 'Lista de leads',
    enviarDocumentoMutation: enviarDocumento,
    recuperarDocumentosQuery: recuperarDocumentosLeadQueryOptions(state.pessoa.id),
  }

  const { t } = useTranslation('leads-represados')

  return (
    <Page
      breadcrumb={[
        { label: t('pages.consulta.breadcrumb'), to: '/leads-represados' },
        { label: t('pages.detalhes.breadcrumb'), to: `/leads-represados/${state.pessoa.id}` },
        { label: t('pages.envio_documentos.breadcrumb') },
      ]}
    >
      <Page.Main>
        <Page.Header>
          <Page.Title>{t('pages.envio_documentos.titulo')}</Page.Title>
          <Page.Description>{t('pages.envio_documentos.descricao')}</Page.Description>
        </Page.Header>
        <Page.Section>
          <EnvioDocumentos config={config}>
            <EnvioDocumentos.Header />
            <EnvioDocumentos.Form />
            <EnvioDocumentos.List />
          </EnvioDocumentos>
        </Page.Section>
      </Page.Main>
    </Page>
  )
}
